import PlaceIcon from '@mui/icons-material/Place';
import { Box, Typography } from '@mui/material';
import React from 'react';

interface Props {
  order: number;
  optimized?: boolean;
  color?: string;
}

// Shared marker size for both normal and optimized states
const DEFAULT_MARKER_SIZE = 48;
const DEFAULT_COLOR = 'primary.main';

export default function EventMapMarker({ order, optimized = false, color }: Props) {
  const markerColor = color ?? DEFAULT_COLOR;
  return (
    <Box
      sx={{
        position: 'relative', // Container keeps pin and order badge positioned together
        width: DEFAULT_MARKER_SIZE,
        height: DEFAULT_MARKER_SIZE,
        cursor: 'pointer',
      }}
    >
      {/* Base location pin shown in both normal and optimized views */}
      <PlaceIcon
        sx={{
          width: DEFAULT_MARKER_SIZE,
          height: DEFAULT_MARKER_SIZE,
          color: markerColor,
          filter: 'drop-shadow(0 4px 8px rgba(0,0,0,.25))', // Add subtle shadow to improve visibility on the map
        }}
      />

      {/* Show route order badge when optimized route is enabled */}
      {optimized && (
        <Box
          sx={{
            position: 'absolute',
            top: '37%', // Position badge inside upper section of the pin
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: DEFAULT_MARKER_SIZE * 0.35,
            height: DEFAULT_MARKER_SIZE * 0.35,
            borderRadius: '50%',
            bgcolor: 'common.white', // White background improves number visibility
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 1px 4px rgba(0,0,0,.25)', // Slight shadow to separate badge from pin
          }}
        >
          {/* Route stop number */}
          <Typography
            sx={{
              color: markerColor,
              fontWeight: 700,
              fontSize: DEFAULT_MARKER_SIZE * 0.25,
              lineHeight: 1,
              userSelect: 'none', // Prevent accidental text selection while interacting with markers
            }}
          >
            {order}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
